
export class ResultPhaseItem {

  public name: string       = '';
  public start: number      = 0;
  public end: number        = 0;
  public duration: number   = 0;
  public completed: boolean = false

  /** standard constructor */
  public constructor(init?: Partial<ResultPhaseItem>) {

    Object.assign(this, init);
  }
}
